export class StepLengthUtil {

    static readonly AVERAGE_STEP: number = 0.71104;
    static readonly MAXIMAL_STEP: number = 2;

    static calculateMyStep(distance: number, count: number) {
        if (count <= 0) count = 1;

        let step = distance / count;

        if (step < this.AVERAGE_STEP || step > this.MAXIMAL_STEP)
            step = this.AVERAGE_STEP;

        return step;
    }
}


// WEBPACK FOOTER //
// /src/tracker/step-length-util.ts